import { Navigate, useParams } from 'react-router-dom';

export function RepairsNewRedirect() {
  return <Navigate to="/repairs" replace state={{ openRepairCreate: true }} />;
}

export function RepairsEditRedirect() {
  const { id } = useParams();
  return <Navigate to="/repairs" replace state={{ openRepairEditId: id }} />;
}

export function RepairsViewRedirect() {
  const { id } = useParams();
  return <Navigate to="/repairs" replace state={{ openRepairViewId: id }} />;
}
